const countrySwitcherForms = document.querySelectorAll("[data-country-selector]");
var delete_cookie = function(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const currentParams = window.location.search;
const currentHash = window.location.hash;

if (countrySwitcherForms && countrySwitcherForms.length) {
    countrySwitcherForms.forEach(form => {
        let countryCodeInput = form.querySelector('input[name="country_code"]');
        let returnToInput = form.querySelector('input[name="return_to"]');
        const buttons = form.querySelectorAll('button[name="country_code--button"]');
        buttons.forEach(button => {
            button.addEventListener("click", event => {
                const baseHref = button.getAttribute('data-shop');
                
                const href = baseHref + (currentParams ? currentParams : '') + (currentHash ? currentHash : '');

                const isoCode = button.value;              
                if (isoCode !== Shopify.country) {
                    countryCodeInput.value = isoCode;
                    returnToInput.value = href;
                    delete_cookie('localization');
                    if (href.includes(Shopify.shop)) {
                        setTimeout(() => {
                            form.submit();
                        }, 200);
                    } else {
                        location.href = href;
                    }
                }
                
            });
        });
    });

}

// Apply order to all language selectors

const allLanguageSelectors = document.querySelectorAll('[id^="language_selector-"]');
  allLanguageSelectors.forEach(selector => {
    addOrderAttributes(selector);
  });

function addOrderAttributes(parentDiv) {
  const eligibleChildren = parentDiv.querySelectorAll(':scope > :not([data-is-glopal="true"])');

  eligibleChildren.forEach((child, index) => {
    child.setAttribute('style', `order: ${index + 1}`);
  });
}